import { get } from './apiClient';
import { RawLabel, UILabel, LabelDeploymentCoverageResponse } from './types';
import { mapLabel } from './mapper';

export interface FetchLabelDeploymentCoverageParams {
  /** Omit for dashboard view (all authorized tenants); pass one id for tenant view. */
  targetTenantIds?: string[];
  searchTerm?: string;
  pageNumber?: number;
  pageSize?: number;
}

export const labelsService = {
  async list(): Promise<UILabel[]> {
    const { data } = await get<RawLabel[]>('/labels');
    return data.map(mapLabel);
  },

  async fetchDeploymentCoverage(
    params: FetchLabelDeploymentCoverageParams = {},
  ): Promise<LabelDeploymentCoverageResponse> {
    const { targetTenantIds, searchTerm, pageNumber = 1, pageSize = 25 } = params;
    const qs = new URLSearchParams();
    if (targetTenantIds && targetTenantIds.length > 0) {
      for (const id of targetTenantIds) qs.append('targetTenantIds', id);
    }
    if (searchTerm) qs.append('searchTerm', searchTerm);
    qs.append('pageNumber', String(pageNumber));
    qs.append('pageSize', String(pageSize));

    const { data } = await get<LabelDeploymentCoverageResponse>(
      `/entities/labels/deployment-coverage?${qs.toString()}`,
    );
    return data;
  },
};
